import React from 'react'

export default function LocationDetailsIcon() {
    return (
        <div className="w-10 h-10 lg:w-12 lg:h-12 bg-gray-100 rounded-full p-2">  {/* Apply Tailwind classes here */}
            <svg
                width="100%"  // Let SVG inherit size from parent container
                height="100%" // Same for height
                viewBox="0 0 50 50"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g clipPath="url(#clip0_6_123)">
                    <path d="M44.9741 14.2744L30.8484 28.4L44.0103 41.5619C44.6186 40.533 44.9741 39.3379 44.9741 38.059V14.2744H44.9741Z" fill="#FFB743" />
                    <path d="M40.3989 42.8396L28.4038 30.8445L14.2744 44.974H38.059C39.3377 44.974 40.5325 44.6185 41.5614 44.0106L40.5019 42.9519C40.4656 42.9156 40.431 42.8784 40.3989 42.8396Z" fill="#FFB743" />
                    <path d="M38.059 0.0258789H6.941C3.12039 0.0258789 0.0259399 3.12903 0.0259399 6.94094V38.0589C0.0259399 41.8708 3.12048 44.9739 6.941 44.9739H9.38726L44.9741 9.38711V6.94094C44.9741 3.12903 41.8709 0.0258789 38.059 0.0258789ZM19.3969 27.5998C19.0684 28.0234 18.5671 28.274 18.0311 28.274C17.4952 28.274 16.9852 28.0233 16.6567 27.5998C15.5157 26.113 9.81072 18.4979 9.81072 14.5216C9.81072 9.99224 13.493 6.30988 18.031 6.30988C22.5604 6.30988 26.2513 9.99215 26.2513 14.5216C26.2514 18.4979 20.5465 26.113 19.3969 27.5998Z" fill="#FFB743" />
                    <path d="M22.7939 14.5217C22.7939 16.2332 20.3218 20.3736 18.0312 23.6237C15.7319 20.3736 13.2684 16.2333 13.2684 14.5217C13.2684 11.9026 15.4035 9.76758 18.0312 9.76758C20.6589 9.76758 22.7939 11.9026 22.7939 14.5217Z" fill="#FFB743" />
                </g>
                <defs>
                    <clipPath id="clip0_6_123">
                        <rect width="45" height="45" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
    )
}
